import React,{useState} from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Yesno from './Yesno';
import {Bill} from './Inc';
import {Tools} from './Tools';
//import useStyles from './Styles';

interface Props {
    bill?:Bill,
    apply:boolean,
    confirm():void,
    cancel():void,
}

const PaymentForm = (props:Props)=> {
    //const classes = useStyles();
    //console.log("payment_form",props.bill);
    const [isOpen,setIsOpen] = useState(false);
    const confirm = ()=>{
        setIsOpen(true);
    }
    const yes = ()=>{
        props.cancel();
    }
    const no = ()=>{
        setIsOpen(false);
    }

    return (
        <div id="payment_form">
            {(props.bill && props.bill.status==="0") ? (
            <div>
                <Divider/>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>支払予定日</TableCell>
                            <TableCell>
                                {props.bill.pay_date ? (
                                    <span>{props.bill.pay_date}</span>
                                ):(
                                    <span>未定</span>
                                )}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>支払予定金額</TableCell>
                            <TableCell>
                                {props.bill.amount ? (
                                    <span>{Tools.comma(props.bill.amount)}円</span>
                                ):(
                                    <span>未定</span>
                                )}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>振込先</TableCell>
                            <TableCell>
                                {props.bill.bank_name ? (
                                    <span>{props.bill.bank_name}</span>
                                ):(
                                    <span>未定</span>
                                )}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>状態</TableCell>
                            <TableCell>
                                支払申請中
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
				{props.bill.cancel_limit ? (
                <FormControl fullWidth={true} style={{marginBottom:"1em",marginTop:"0.5em"}}>
                    <Button variant="outlined" color="secondary" style={{width:"100%"}} onClick={confirm}><CloseIcon/>キャンセルする</Button>
                    <FormHelperText>※{props.bill.cancel_limit}までキャンセル可能</FormHelperText>
                </FormControl>
				):(
				<div style={{marginBottom:"2em",marginTop:"0.5em",fontSize:'90%',color:'#666666',lineHeight:'1.5em'}}>※この申請をキャンセルしたい場合は架空ストアまでご一報ください。</div>
				)}
            </div>
            ):(
            <FormControl fullWidth={true} style={{marginBottom:"1em"}}>
                <Button variant="contained" color="primary" disabled={!props.apply} style={{width:"100%"}} onClick={props.confirm}><EditIcon/>支払申請する</Button>
            </FormControl>
            )}
            <Yesno mes="キャンセルしてよろしいですか？" yes={yes} no={no} isOpen={isOpen}/>
        </div>
    );
}

export default PaymentForm;
